import { apiCall } from './gqlClient';
const GETALLORDERS_QUERY = "\n  query getAllOrders($startTime: DateTime, $endTime: DateTime) {\n    getAllOrders(startTime: $startTime, endTime: $endTime)\n  }";
export const getAllOrdersApiCall = async _ref => {
  let {
    startTime,
    endTime
  } = _ref;
  return apiCall({
    query: GETALLORDERS_QUERY,
    variables: {
      startTime,
      endTime
    }
  });
};
const GETMYORDERS_QUERY = "\n  query getMyOrders {\n    getMyOrders\n    {\n      id\n\t\t\tuserId\n\t\t\tcustomerId\n\t\t\tproviderId\n\t\t\tproductId\n\t\t\treservationId\n\t\t\tsubscriptionId\n\t\t\tuserMembershipId\n\t\t\tdate\n\t\t\tprice\n\t\t\tpaid\n\t\t\tstripeId\n\t\t\temail\n\t\t\tserviceId\n\t\t\tname\n\t\t\tpaidWithUserMembershipId\n\t\t\ttype\n\t\t\tduration\n\t\t\tresourceName\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tcolor\n\t\t\tgroupName\n\t\t\ttimeUnit\n\t\t\tcurrency\n\t\t\tactive\n      ...fragments\n    }\n  }";
export const getMyOrdersApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETMYORDERS_QUERY,
    variables: {},
    fragments
  });
};
const GETORDEREVENTS_QUERY = "\n  query getOrderEvents($orderId: Int!) {\n    getOrderEvents(orderId: $orderId)\n    {\n      id\n\t\t\torderId\n\t\t\ttype\n\t\t\tprice\n\t\t\tpaid\n\t\t\tmethod\n\t\t\tchannel\n\t\t\tmembershipId\n\t\t\tcreated\n      ...fragments\n    }\n  }";
export const getOrderEventsApiCall = async function (_ref2) {
  let {
    orderId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETORDEREVENTS_QUERY,
    variables: {
      orderId
    },
    fragments
  });
};
const CREATEORDEREVENT_QUERY = "\n  mutation createOrderEvent($request: OrderEventInput!) {\n    createOrderEvent(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const createOrderEventApiCall = async function (_ref3) {
  let {
    request
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEORDEREVENT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const MARKORDERASPAID_QUERY = "\n  mutation markOrderAsPaid($id: Int!) {\n    markOrderAsPaid(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const markOrderAsPaidApiCall = async function (_ref4) {
  let {
    id
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: MARKORDERASPAID_QUERY,
    variables: {
      id
    },
    fragments
  });
};